module.exports = __webpack_public_path__ + "img/house_wifi.3f0cf247.svg";